import i18n, { tDynamic } from '@/i18n'

export interface ApiErrorInfo {
  status: number
  code?: string
  params?: Record<string, unknown>
  serverMessage?: string
}

/**
 * 백엔드 message 필드 정규화. 검증 오류(ValidationPipe·Zod 호환 본문)는 string[] 을
 * 보낼 수 있다 (VALIDATION_FAILED).
 */
export function normalizeServerMessage(message: unknown): string | undefined {
  if (Array.isArray(message)) return message.join(', ')
  return typeof message === 'string' && message.length > 0 ? message : undefined
}

/**
 * 백엔드 에러를 현재 UI 언어의 메시지로 해석한다.
 * - ko UI: 백엔드 원문(한국어)을 그대로 신뢰 — 기존 동작과 100% 동일하며,
 *   VALIDATION_FAILED 같은 동적 상세 메시지도 손실 없이 표시된다.
 * - 그 외 언어: errorCode 가 카탈로그(errors.*)에 있으면 번역 사용 (params 보간),
 *   없으면 상태 코드 기반 일반 메시지로 폴백.
 */
export function resolveApiErrorMessage({ status, code, params, serverMessage }: ApiErrorInfo): string {
  const original = normalizeServerMessage(serverMessage)
  if (i18n.language === 'ko' && original) return original
  if (code) {
    const translated = tDynamic(`errors.${code}`, params)
    if (translated) return translated
  }
  if (status >= 500) return i18n.t('errors.SERVER_ERROR')
  return i18n.t('errors.UNEXPECTED')
}
